const CARTO_LEAFLET_BASE =
  'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';

/**
 * Leaflet TileLayer URL for CARTO Voyager raster basemaps.
 * Set REACT_APP_CARTO_BASEMAPS_API_KEY at build time (GitHub Environment secrets).
 */
export function cartoVoyagerLeafletTileUrl(): string {
  const key = process.env.REACT_APP_CARTO_BASEMAPS_API_KEY?.trim();
  if (!key) return CARTO_LEAFLET_BASE;
  return `${CARTO_LEAFLET_BASE}?key=${encodeURIComponent(key)}`;
}
